import React, { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets the window scroll position on route changes.
 *
 * React Router keeps the current scroll offset when the route changes, so a
 * link clicked from the footer opens the next page already scrolled to its
 * bottom. Back/forward navigation is left alone so the browser can restore the
 * position the user came from.
 *
 * Renders nothing, but has to live inside the Router to read the location.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;

    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
